import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ComponentType, ReactNode } from 'react';
import { IJobDetailsService } from '../../jobDetails.service';
import { JobDetailsStore } from '../../jobDetails.store';
import { JOB_TYPE } from '../../jobs.model';

export const withValidType = <P,>(Component: ComponentType<P>): ((props: P) => ReactNode) => {
  return observer((props: P): ReactNode => {
    const jobDetailsService = useInjection(IJobDetailsService.$);
    const jobType = (jobDetailsService.store as JobDetailsStore).jobType;
    if (jobType === JOB_TYPE.UNKNOWN) {
      return <></>;
    }

    // We have to use any because of existing bug in Emotion types
    // https://github.com/emotion-js/emotion/issues/3245
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <Component {...(props as any)} />;
  });
};
